/**
 * Country codes accepted by the address-book Add-number form. Ported
 * verbatim from bridge-frontend (`src/constants/Country.js`) so the two
 * apps stay interchangeable — same code, same expected phone length.
 * If bridge grows this list, mirror it here rather than diverging.
 *
 * `code` is the numeric country code (sent to the backend), `length` is
 * the expected count of digits the phone number takes after the code,
 * and `label` is the display string used in the picker.
 */
const COUNTRY_CODES = [
  { label: "+91 India",         value: "India",        code: 91,  length: 10 },
  { label: "+971 UAE",          value: "UAE",          code: 971, length: 9  },
  { label: "+1 US",             value: "US",           code: 1,   length: 10 },
  { label: "+1 Canada",         value: "Canada",       code: 1,   length: 10 },
  { label: "+44 UK",            value: "UK",           code: 44,  length: 10 },
  { label: "+61 Australia",     value: "Australia",    code: 61,  length: 9  },
  { label: "+63 Philippines",   value: "Philippines",  code: 63,  length: 10 },
  { label: "+27 South Africa",  value: "South Africa", code: 27,  length: 9  },
  { label: "+987 MLI NRI",      value: "MLI NRI",      code: 987, length: 10 },
];

export default COUNTRY_CODES;

/** Default (+91 India) — bridge opens with the first entry, we match. */
export const DEFAULT_COUNTRY = COUNTRY_CODES[0];
